module.exports = "<iframe  [ngStyle]=\"{'background-image': 'url(' + imageSourceUrl + ')', 'background-repeat': 'no-repeat', 'background-position': 'center', 'background-size': '70px 70px'}\"\n        #ipPaymentsFrm id=\"ipPaymentsIframe\" width=\"100%\" height=\"560px\" scrolling=\"no\" (unload)=\"onContentUnload()\" (load)=\"onContentLoad()\">\n</iframe>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/ippayment/ippayment.component.html
// module id = ./src/app/shared/components/ippayment/ippayment.component.html
// module chunks = main